export const ChangeLogColumns = [
  {
    accessor: 'logRecord',
  },
];

export const MAX_AMOUNT_OF_ITEMS_ON_PAGE = 10;

export const MAX_AMOUNT_OF_ITEMS_ON_CASE_PAGE = 25;
